module.exports = __webpack_public_path__ + "media/images/custom_page/limyoungmin_event/limyoungmin-event-ja-96e660d9c0bd7bc1260ada32418748f8.png";